import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=63f1580e&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1580e",
  null
  
)

export default component.exports